/* Lazy, muted video previews. Touch retains normal product links. */
(() => {
 const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
 const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
 function init(scope) {
  const cards = [...scope.querySelectorAll('.card-wrapper')];
  if (scope.matches?.('.card-wrapper')) cards.unshift(scope);
  cards.forEach(card => {
   const video = card.querySelector('.d4u-hover-video');
   if (!video || card.dataset.d4uVideoReady) return;
   card.dataset.d4uVideoReady = 'true';
   let active = false, generation = 0;
   function stop() {
    active = false; generation++;
    card.classList.remove('d4u-video-playing'); video.pause();
    try { video.currentTime = 0; } catch (_) {}
   }
   card.addEventListener('pointerenter', () => {
    if (!hover.matches || reduced.matches) return;
    active = true;
    const token = ++generation;
    if (!video.dataset.loaded) {
     video.querySelectorAll('source[data-src]').forEach(s => { s.src = s.dataset.src; });
     video.dataset.loaded = 'true'; video.load();
    }
    video.muted = true;
    const play = video.play();
    if (play) play.then(() => {
     if (active && token === generation) card.classList.add('d4u-video-playing');
     else if (!active) video.pause();
    }).catch(() => { if (token === generation) stop(); });
   });
   card.addEventListener('pointerleave', stop);
   video.addEventListener('error', stop);
   document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); });
   hover.addEventListener('change', stop); reduced.addEventListener('change', stop);
   if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) stop(); });
    observer.observe(card);
   }
  });
 }
 // Recommendations and filtered grids insert cards after the initial page load.
 const updates = new MutationObserver(records => {
  for (const record of records) {
   for (const node of record.addedNodes) {
    if (node.nodeType !== 1) continue;
    init(node);
    const card = node.closest('.card-wrapper');
    if (card && card !== node) init(card);
   }
  }
 });
 updates.observe(document.documentElement, { childList: true, subtree: true });
 init(document);
 document.addEventListener('shopify:section:load', event => init(event.target));
})();
